import { NodeViewWrapper } from "@tiptap/react"

import { CodeBlock } from "@/features/chat/components/code-block"

type CodeBlockNodeViewProps = {
  node: {
    attrs?: {
      language?: string | null
    }
    textContent: string
  }
}

export function CodeBlockNodeView({ node }: CodeBlockNodeViewProps) {
  const language = typeof node.attrs?.language === "string" ? node.attrs.language : ""
  const className = language ? `language-${language}` : undefined

  return (
    <NodeViewWrapper contentEditable={false}>
      <CodeBlock className={className} inline={false}>
        {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
        {node.textContent ?? ""}
      </CodeBlock>
    </NodeViewWrapper>
  )
}
